import { MenuContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { IMenuItem } from "src/libs/interfaces/layouts"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import { showToast } from "src/libs/useful"
import { Intent } from "@blueprintjs/core"
import HeaderUnderMenu from "src/libs/layout-app/header/HeaderUnderMenu"
import HeaderMenuMainButton from "src/libs/layout-app/header/HeaderMenuMainButton"

const MenuScreen = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: MenuContent = ( props.primitive || {} ) as MenuContent
    useEffect(() => {
        addCSSClass(
            `menu-item-${primitive.id}`,
            `.menu-item-${primitive.id} {
                ${primitive.style?.color ? `color: ${primitive.style?.color}!important;` : ""}
                ${primitive.text_color ? `color: ${primitive.text_color}!important;` : ""}
            }`,
            true
        )
        return () => {
            removeCSSClass(`menu-item-${primitive.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const items: IMenuItem[] = primitive.items?.length  
        ?
        primitive.items
        :
        [] 
    const onRoute = (anchor: string) => {
        const element = document.getElementById( anchor.replace( "#", "" ) ) 
        if(!!element) { 
            const lScroll = getLandingContainer().scrollTop   
            getLandingContainer().scrollTo({
                behavior: 'smooth',
                top: lScroll + element.getBoundingClientRect().top,
            })
        }
        else {
            showToast({
                message: "Error.Not exists this section",
                intent: Intent.DANGER
            })
        } 
    }
    return <div className={`pe-primitive-container landing-menu-primitive p-1 ${primitive.className || ""}`} data-primitive-type={primitive["data-primitive-type"]}> 
        {
            items.map((item, i) => {
                if ( Array.isArray(item.children) ) {
                    return <HeaderUnderMenu 
                        i={i} 
                        item={{
                            ...item,
                            animated: primitive.animated,
                            animated_delay: primitive.animated_delay
                        }} 
                        key={i} 
                        isForceOpen
                        header_menu={primitive.design_type || "inline"}
                        pt="0"
                        className={ `${item.className || ""} ${primitive.className || ""} menu-item-${primitive.id}` }
                        style={primitive.style}
                    />
                } 
                return <HeaderMenuMainButton
                    item={{
                            ...item,
                            animated: primitive.animated,
                            animated_delay: primitive.animated_delay
                        }}
                    i={ i }
                    key={ i } 
                    pt="0"
                    isForceOpen
                    header_menu={primitive.design_type || "inline"}
                    className={ `${item.className || ""}  ${primitive.className || ""} menu-item-${primitive.id}` }
                    style={primitive.style}
                    onRoute={onRoute}
                />
            })
        } 
    </div>  
}

export default MenuScreen